<template>
  <v-layout align-center justify-center class="event-detail-item" v-if="event">
    <v-flex md2 xs1 class="image-center">
      <div class="event-type-icon text-md-center">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-img
              v-on="getAccessMode === 'nbe' ? on : ''"
              :src="
                require(`../assets/images/icons/svg/${chooseIcon(event.type)}`)
              "
              height="24px"
              width="24px"
            ></v-img>
          </template>
          <span>{{ event }}</span>
        </v-tooltip>
      </div>
    </v-flex>
    <v-flex md3 xs3>
      <p>{{ event.dt | formatDateString("HH:mm:ss") }}</p>
    </v-flex>
    <v-flex md7 x8>
      <!-- Type 0 - Setup values -->
      <p v-if="event.type === '0'">
        <span
          >{{ event.txt | translate }} {{ event.from }}
          {{ event.unit | translate }}</span
        >
        <v-img
          :src="require(`../assets/images/icons/svg/ic_arrow_forward.svg`)"
        ></v-img>
        <span>{{ event.to }} {{ event.unit | translate }}</span>
      </p>

      <!-- Type 1 - State changes -->
      <p v-if="event.type === '1'">
        <span>{{ `lng_state_${event.from}` | translate }}</span>
        <v-img
          :src="require(`../assets/images/icons/svg/ic_arrow_forward.svg`)"
        ></v-img>
        <span>{{ `lng_state_${event.to}` | translate }}</span>
      </p>

      <!-- Type 2 - subevents with various parameters -->
      <p v-if="event.type === '2' && event.count === '0'">
        <span>{{ event.txt | translate }}</span>
      </p>

      <p v-if="event.type === '2' && event.count === '1'">
        <span
          >{{ event.txt | translate }} {{ event.from }}
          {{ event.unit | translate }}</span
        >
      </p>

      <p v-if="event.type === '2' && event.count === '2'">
        <span
          >{{ event.txt | translate }} {{ event.from }}
          {{ event.unit | translate }} {{ event.to }}
          {{ event.unit | translate }}</span
        >
      </p>

      <p v-if="event.type === '2' && event.count === '3'">
        <span
          >{{ event.txt | translate }} {{ event.from }}
          {{ event.unit | translate }} {{ event.to }}
          {{ event.unit | translate }} {{ event.val3 }}
          {{ event.unit | translate }}</span
        >
      </p>

      <p v-if="event.type === '9'">
        <span>{{ event.txt | translate }}</span>
        <span v-if="event.eventid === '0' && event.to === '1'">{{
          event.from
        }}</span>
      </p>

      <p v-if="event.type === '8'">
        <span>{{ event.txt | translate }} {{ event.from }}</span>
        <v-img
          v-if="event.parms === '2'"
          :src="require(`../assets/images/icons/svg/ic_arrow_forward.svg`)"
        ></v-img>
        <span v-if="event.parms === '2'">{{ event.to }}</span>
      </p>

      <p v-if="event.type === '4'">
        <span>{{ `lng_info_${event.eventid}` | translate }}</span>
      </p>

      <!-- Old attempt to handle alarm icon... not used anymoer -->
      <p v-if="event.type === '20'">
        <span>{{ `state_${event.from}` | translate }}</span>
        <v-img
          :src="require(`../assets/images/icons/svg/ic_arrow_forward.svg`)"
        ></v-img>
        <span>{{ `state_${event.to}` | translate }}</span>
      </p>

      <p v-if="event.type === '7'">
        <span v-if="event.eventid === '35' || event.eventid === '36'"
          >{{ ("lng_subevent_" + event.eventid) | translate }} L{{ event.from }}
        </span>
        <span v-else>{{ ("lng_subevent_" + event.eventid) | translate }}</span>
      </p>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "EventItem",
  data() {
    return {
      event: false
    };
  },
  props: {
    eventsData: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    eventsData: function(newVal) {
      this.event = newVal;
    }
  },
  computed: {
    ...mapGetters("global", ["getAccessMode"])
  },
  mounted() {
    this.event = this.eventsData;
  },
  methods: {
    chooseIcon(eventType) {
      if (eventType === "0") return "ic_settings.svg";
      else if (eventType === "1") return "ic_chat_bubble_outline.svg";
      else if (
        eventType === "2" ||
        eventType === "7" ||
        eventType === "4" ||
        eventType === "9" ||
        eventType === "8"
      )
        return "ic_info_outline.svg";
      else if (eventType === 20) return "ic_alert.svg";
    }
  }
};
</script>
